export default __webpack_public_path__ + "static/typography-image-c-5dfc5999294de72de2b31cceb5f6e8b3.png";